export default __webpack_public_path__ + "static/media/Icon7.11bb74f1.svg";